import React from 'react';
import withIcon from '../utilities/withIcon';

const IconHappy = () => {
  return (
    <g>
      <path d="m11.873 8.83a.7482.7482 0 0 0 -.96.4522 3.074 3.074 0 0 1 -5.7754-.001.75.75 0 0 0 -1.41.51 4.5741 4.5741 0 0 0 8.5977-.001.7513.7513 0 0 0 -.4523-.9602z" />
      <path d="m8 .125a7.875 7.875 0 1 0 7.875 7.875 7.8833 7.8833 0 0 0 -7.875-7.875zm0 14.25a6.375 6.375 0 1 1 6.375-6.375 6.3817 6.3817 0 0 1 -6.375 6.375z" />
      <circle cx="4.6871" cy="6.3912" r="1.1271" />
      <circle cx="11.4028" cy="6.3912" r="1.1271" />
    </g>
  );
};

export default withIcon(IconHappy);
